var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCircle = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66663C8.64801 2.66663 2.66667 8.64796 2.66667 16C2.66801 23.3533 8.64934 29.3346 16 29.3346C23.352 29.3346 29.3333 23.3533 29.3347 16C29.3347 8.64796 23.3533 2.66663 16 2.66663ZM16 26.668C10.12 26.668 5.33467 21.8826 5.33334 16C5.33334 10.1186 10.1187 5.33329 16 5.33329C21.8827 5.33329 26.668 10.1186 26.668 16C26.6667 21.8826 21.8813 26.668 16 26.668Z",
    fill: "#08C5A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.65 16C21.65 16.742 21.5039 17.4767 21.2199 18.1622C20.936 18.8477 20.5198 19.4705 19.9952 19.9952C19.4705 20.5198 18.8477 20.936 18.1622 21.2199C17.4767 21.5039 16.742 21.65 16 21.65C15.258 21.65 14.5233 21.5039 13.8378 21.2199C13.1523 20.936 12.5295 20.5198 12.0048 19.9952C11.4802 19.4705 11.064 18.8477 10.7801 18.1622C10.4961 17.4767 10.35 16.742 10.35 16",
    stroke: "#08C5A7",
    strokeWidth: 2.7
  })));
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle.f48c02d6.svg";
export { ForwardRef as ReactComponent };